module.exports = __webpack_public_path__ + "static/media/iconThree.93829dab.svg";